import React, { useState } from "react";
import styles from "./styles.module.scss";
import { Avatar, Button, Input, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Space, Table, Tag } from "antd";
import { CPUIcon, ViewDetailsIcon } from "icons";
import { TicketsSearchFilter } from "pages/support-tickets/components";
import { TicketDetailModal } from "../ticket-detail-modal";
import { UseApiCallV2 } from "hooks";
import { TicketDetailModalV1 } from "../ticket-detail-modal copy";
import { getSearchedItem } from "utils/helpers";

export const TicketsTable = () => {
  const [openTicketDetailModal, setOpenTicketDetailModal] = useState(false);
  const [searchVal, setSearchVal] = useState("");

  const {
    data: ticketsData,
    isLoading,
    refetch: refetchTicketsData,
  } = UseApiCallV2({
    url: "/get_all_tickets",
    method: "POST",
    paramsData: {
      token: "null",
    },
  });

  function handleClickDetail(record) {
    setOpenTicketDetailModal(true);
    setTicketId(record);
  }
  let tickets = ticketsData;
  tickets = getSearchedItem({ searchText: searchVal, listOfObjects: tickets });

  const columns = [
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar src="https://avatar.iran.liara.run/public/68"></Avatar>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Date",
      dataIndex: "userid",
      key: "userid",
    },
    {
      title: "Subject",
      dataIndex: "topic",
      key: "topic",
      ellipsis: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <button
            className={styles.viewDetailsBtn}
            onClick={() => handleClickDetail(record)}
          >
            <span>
              <ViewDetailsIcon />
            </span>{" "}
            View Details
          </button>
        </Space>
      ),
    },
  ];

  const [expanded, setExpanded] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedIssueType, setSelectedIssueType] = useState("all");
  const [ticketId, setTicketId] = useState(null);

  function handleChangeTicketPreference(data) {
    setSelectedStatus(data?.value);
  }
  function handleChangeIssueType(data) {
    setSelectedIssueType(data?.value);
  }
  return (
    <Spin spinning={isLoading}>
      <div className={styles.tableContainer}>
        <div style={{ marginBottom: "50px" }}>
          <TicketsSearchFilter
            setSearchVal={setSearchVal}
            searchVal={searchVal}
            handleChangeTicketPreference={handleChangeTicketPreference}
            handleChangeIssueType={handleChangeIssueType}
          />
        </div>
        <Table
          columns={columns}
          dataSource={tickets}
          pagination={true}
          rowClassName={styles.row}
        />
        <TicketDetailModalV1
          openTicketDetailModal={openTicketDetailModal}
          ticketData={ticketId}
          refetchTicketsData={refetchTicketsData}
          setOpenTicketDetailModal={setOpenTicketDetailModal}
        />
      </div>
    </Spin>
  );
};
